import { __decorate } from "tslib";
import { Route } from '../core';
var TariffMobileShop = /*@__PURE__*/ (function () {
    function TariffMobileShop() {
    }
    TariffMobileShop.get = function (response) {
        return response;
    };
    TariffMobileShop = __decorate([
        Route('/vlux/subscriptions/tariffmobile-shop.json')
    ], TariffMobileShop);
    return TariffMobileShop;
}());
export { TariffMobileShop };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/endpoints/tariffmobile-shop.ts
// module id = null
// module chunks = 